<template>
	<div class="MasterCategoriesItem">
		<h3
			class="MasterCategoriesItem__name"
			:class="{
				'MasterCategoriesItem__name--active': item.id === selectedMasterCategory.id
			}"
		>
			{{ name }}
		</h3>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: [
		'item',
	],

	computed: {
		...mapGetters({
			selectedMasterCategory: 'categories/selectedMasterCategory',
		}),

		name () {
			return this.getTranslation(this.item.name)
		},
	},
}
</script>

<style lang="scss" scoped>
	.MasterCategoriesItem {
		width: 50%;
		padding: 0 10px;
		text-align: center;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		margin-bottom: 8px;

		&__name {
			position: relative;
			margin: 0;

			&--active {
				&::before {
					content: '';
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 2px;
					background: #24242E;
				}
			}
		}
	}
</style>
